const CART_STORAGE_KEY = 'emporion_cart_id'
const CART_COOKIE_KEY = 'emporion_cart_id'
const CART_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365
const CUSTOMER_USER_ID_KEY = 'emporion_customer_user_id'
const CHECKOUT_GUEST_CART_STORAGE_KEY = 'emporion_checkout_guest_cart_id'
const CHECKOUT_GUEST_CART_COOKIE_KEY = 'emporion_checkout_guest_cart_id'

const shouldUseSecureCookie = () => {
  if (typeof window === 'undefined') return false
  if (window.location.protocol === 'https:') return true
  return (
    typeof process !== 'undefined' &&
    typeof process.env?.NODE_ENV === 'string' &&
    process.env.NODE_ENV === 'production'
  )
}

const readCookieValue = (key: string) => {
  if (typeof window === 'undefined') return null
  const raw = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${key}=`))
  if (!raw) return null
  const value = decodeURIComponent(raw.slice(key.length + 1)).trim()
  return value || null
}

const writeCookieValue = (key: string, value: string | null) => {
  if (typeof window === 'undefined') return
  const secureSuffix = shouldUseSecureCookie() ? '; Secure' : ''
  if (!value) {
    document.cookie = `${key}=; Max-Age=0; Path=/; SameSite=Lax${secureSuffix}`
    return
  }
  document.cookie = `${key}=${encodeURIComponent(value)}; Max-Age=${CART_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secureSuffix}`
}

export const readStoredCartId = () => {
  if (typeof window === 'undefined') return null
  const localValue = window.localStorage.getItem(CART_STORAGE_KEY)?.trim()
  if (localValue) return localValue
  return readCookieValue(CART_COOKIE_KEY)
}

export const writeStoredCartId = (cartId: string | null) => {
  if (typeof window === 'undefined') return
  if (!cartId) {
    window.localStorage.removeItem(CART_STORAGE_KEY)
    writeCookieValue(CART_COOKIE_KEY, null)
    return
  }
  window.localStorage.setItem(CART_STORAGE_KEY, cartId)
  writeCookieValue(CART_COOKIE_KEY, cartId)
}

export const readStoredCustomerUserId = () => {
  if (typeof window === 'undefined') return null
  const candidate = window.localStorage.getItem(CUSTOMER_USER_ID_KEY)?.trim()
  return candidate || null
}

export const readCheckoutGuestCartId = () => {
  if (typeof window === 'undefined') return null
  const localValue = window.localStorage.getItem(CHECKOUT_GUEST_CART_STORAGE_KEY)?.trim()
  if (localValue) return localValue
  return readCookieValue(CHECKOUT_GUEST_CART_COOKIE_KEY)
}

export const writeCheckoutGuestCartId = (cartId: string | null) => {
  if (typeof window === 'undefined') return
  if (!cartId) {
    window.localStorage.removeItem(CHECKOUT_GUEST_CART_STORAGE_KEY)
    writeCookieValue(CHECKOUT_GUEST_CART_COOKIE_KEY, null)
    return
  }
  window.localStorage.setItem(CHECKOUT_GUEST_CART_STORAGE_KEY, cartId)
  writeCookieValue(CHECKOUT_GUEST_CART_COOKIE_KEY, cartId)
}

export const isCartIdentityStorageKey = (key: string | null) =>
  !key ||
  key === CART_STORAGE_KEY ||
  key === CUSTOMER_USER_ID_KEY ||
  key === CHECKOUT_GUEST_CART_STORAGE_KEY
